@if (selectable) {
    <!-- Button -->
    <button
        mat-icon-button
        [matMenuTriggerFor]="languagesMenu"
        [matTooltip]="'language.tooltip' | transloco"
        [attr.aria-label]="'language.tooltip' | transloco"
    >
        <ng-container
            *ngTemplateOutlet="flagImage; context: { $implicit: active }"
        ></ng-container>
    </button>

    <!-- Language menu -->
    <mat-menu [xPosition]="'before'" #languagesMenu="matMenu">
        @for (lang of languages; track lang.id) {
            <button
                mat-menu-item
                [class.font-semibold]="lang.id === active.id"
                (click)="setActiveLang(lang.id)"
            >
                <span class="flex items-center">
                    <ng-container
                        *ngTemplateOutlet="
                            flagImage;
                            context: { $implicit: lang }
                        "
                    ></ng-container>
                    <span class="ml-3">{{ lang.label }}</span>
                </span>
            </button>
        }
    </mat-menu>

    <!-- Flag image template -->
    <ng-template let-lang #flagImage>
        <span class="relative w-6 overflow-hidden rounded-sm shadow">
            <span
                class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"
            ></span>
            <img
                class="w-full"
                [src]="'images/flags/' + lang.flag + '.svg'"
                [alt]="'language.flagAlt' | transloco: { language: lang.label }"
            />
        </span>
    </ng-template>
}
